module.exports = __webpack_public_path__ + "img/636466.c5e844cc.svg";